module.exports = __webpack_public_path__ + "static/media/vinswap.269e12a0.jpg";